export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getAccountBillingSummary: function getAccountBillingSummary(accountNumber) {
            return JsonRPCService.send('bc', 'gatewaybilling/billingData', 'getAccountBillingSummary', [accountNumber]);
        },
        getAccountBillingDetails: function getAccountBillingDetails(accountNumber) {
            return JsonRPCService.send('bc', 'gatewaybilling/billingData', 'getAccountBillingDetails', [accountNumber]);
        },
        getInvoiceStreamDetails: function getInvoiceStreamDetails(accountNumber, invoiceStreamId) {
            return JsonRPCService.send('bc', 'gatewaybilling/billingData', 'getInvoiceStreamDetails', [accountNumber, invoiceStreamId]);
        },
        getPaymentGroupPaymentInformation: function getPaymentGroupPaymentInformation(accountNumber, groupId) {
            return JsonRPCService.send('bc', 'gatewaybilling/billingData', 'getPaymentGroupPaymentInformation', [accountNumber, groupId]);
        },
        setPaymentGroupPaymentInformation: function setPaymentGroupPaymentInformation(accountNumber, groupId, instrument) {
            return JsonRPCService.send('bc', 'gatewaybilling/billingData', 'setPaymentGroupPaymentInformation', [accountNumber, groupId, instrument]);
        },
        getAccountBillingAddress: function getAccountBillingAddress(accountNumber) {
            return JsonRPCService.send('bc', 'gatewaybilling/billingData', 'getAccountBillingAddress', [accountNumber]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/billing/services/GatewayAccountBillingDetailsService.js
// module id = 150
// module chunks = 0